import type {QueryClient} from 'react-query';

function scrollOrdersListToTop() {
	const scrollContainer = document.querySelector('main.overflow-y-auto');

	if (scrollContainer instanceof HTMLElement) {
		scrollContainer.scrollTo({top: 0, behavior: 'instant'});
		return;
	}

	window.scrollTo({top: 0, behavior: 'instant'});
}

export async function refreshOrdersTableFirstPage(queryClient: QueryClient) {
	scrollOrdersListToTop();
	await queryClient.resetQueries({queryKey: ['tasks', 'infinite']});
}
